import React, { useState, useEffect } from 'react';
import styles from '../App.module.css';
import { useLocation, useParams } from 'react-router-dom';

function Event_inner() {
  const [eventBanner, setEventBanner] = useState({});
  const [eventDetails, setEventDetails] = useState({});
  const [upcomingEvents, setUpcomingEvents] = useState([]);
  const location = useLocation();
  const slug = location.pathname.split("/")[1];
  const baseurl = process.env.REACT_APP_API_BASE_URL;
  const url = useParams();
  const getEventBanner = async() => {
    try {
      const response = await fetch(`${baseurl}get-pages.php/${slug}`);
      const result = await response.json();
      setEventBanner(result.data.length > 0 && result.data[0]); // Adjust based on your API response       
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {}
  };
  const getEventDetails = async() => {
    try {
      const response = await fetch(`${baseurl}get-event-details.php/${url.name}`);
      const result = await response.json();
      setEventDetails(result.data.length > 0 && result.data[0]); // Adjust based on your API response       
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {}
  };
  const getUpcomingEvents = async() => {
    try {
      const response = await fetch(`${baseurl}get-upcoming-events.php`);
      const result = await response.json();
      setUpcomingEvents(result.data); // Adjust based on your API response       
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {}
  };
  useEffect(() => {
    getEventBanner(); 
    getEventDetails();
    getUpcomingEvents();
  }, [])
  
  return (
    <>
      <section id="home" className={`${styles.hero} ${styles.about_banner}`} data-aos="fade-up" style={{backgroundImage:`url(${eventBanner.banner_image})`}}>
        <div className="container mx-auto">
          <div className='row'>
            <div className="col-md-12">            
              <h1 className='font-bold leading-12 text-5xl'>Event</h1>
              <p className="text-white text-xl font-semibold mt-2 mb-0 w-50">it is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
            </div>
          </div>
        </div>
      </section>
      <section className="py-20">
          <div className="container">
              <div className="row mt-5 bg-white p-5 align-items-center">
                  <div className="col-md-7 text-center">
                      <img loading="lazy" src={eventDetails.image} alt={eventDetails.title}/>
                  </div>
                  <div className="col-md-5">
                      <div>
                          <p className='text-yellow-400 text-sm font-normal uppercase mb-0'>{eventDetails.title}</p>
                          <h2 className="text-5xl font-bold uppercase text-dark w-3/5">{eventDetails.sub_title}</h2>
                          <p className='text-dark mb-0 text-sm font-semibold'>{eventDetails.short_description}</p>
                      </div>
                  </div>
              </div>
              <div className="row mt-5">
                  <div className="col-md-12">
                      <h2 className="text-5xl font-bold uppercase text-white">up coming event</h2>
                      <div className={`grid mt-5 ${upcomingEvents.length ? "grid-cols-3": ""} gap-5`}>                
                          {upcomingEvents.length ? upcomingEvents.map(item => (                  
                              <EventInnerCard key={item.title} image={item.image} heading={item.title} />
                          )) : <p className='mb-0 text-xl text-white m-auto d-inline'>No Event Found!</p>}
                      </div>
                  </div>
              </div>
          </div>
      </section>
    </>
  )
}

function EventInnerCard({ image, heading }) {
    return (
      <div className="relative w-full max-w-sm mx-auto bg-white rounded-lg overflow-hidden shadow-lg h-96">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${image})`}}
        ></div>
        <div className="relative h-full flex flex-col justify-end p-4">
          <h2 className="text-2xl font-bold text-white mb-4 capitalize">{heading}</h2>
          <a href="javascript:void(0)" className="text-yellow-400 d-flex align-items-center text-decoration-none">
            Read More
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="ms-2 bi bi-arrow-right" viewBox="0 0 16 16">
              <path fillRule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>
            </svg>
          </a>
        </div>
      </div>
    )
  }

export default Event_inner